import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { CATEGORY_EXAMPLES } from "../constants/categoryExamples";

export default function CategoryExampleButton({ category }) {
  // モーダル表示状態
  const [open, setOpen] = useState(false);

  const example = CATEGORY_EXAMPLES[category];

  if (!example) return null;

  return (
    <>
      <Button size="small" variant="outlined" onClick={() => setOpen(true)}>
        記入例を見る
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
        aria-labelledby={`category-example-dialog-title-${category}`}
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: "hidden",
          },
        }}
      >
        {/* ヘッダー：アイコン＋タイトル＋閉じる(×) */}
        <DialogTitle
          id={`category-example-dialog-title-${category}`}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            px: 3,
            py: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
            <DescriptionOutlinedIcon
              sx={{ fontSize: 20, color: "text.secondary" }}
            />
            <Typography
              component="span"
              sx={{
                fontSize: { xs: "0.95rem", sm: "1rem" },
                fontWeight: 600,
              }}
            >
              {example.title}の記入例
            </Typography>
          </Box>

          <IconButton
            size="small"
            onClick={() => setOpen(false)}
            aria-label="閉じる"
            sx={{ color: "text.secondary" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <Divider />

        <DialogContent sx={{ px: 3, py: 2.5 }}>
          {/* カテゴリー */}
          <Box
            sx={{
              borderLeft: "3px solid",
              borderColor: "primary.main",
              pl: 1.5,
              py: 0.25,
              mb: 2.5,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                letterSpacing: "0.02em",
                display: "block",
                lineHeight: 1.4,
              }}
            >
              カテゴリー
            </Typography>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: { xs: "0.9rem", sm: "0.95rem" },
                lineHeight: 1.5,
              }}
            >
              {example.category}
            </Typography>
          </Box>

          {/* 業務内容 */}
          <Typography
            sx={{
              mb: 1.25,
              fontSize: "0.8rem",
              fontWeight: 600,
              color: "text.secondary",
              letterSpacing: "0.04em",
            }}
          >
            業務内容
          </Typography>

          <Typography
            sx={{
              whiteSpace: "pre-wrap",
              fontSize: { xs: "0.875rem", sm: "0.9375rem" },
              lineHeight: 1.85,
              color: "text.primary",
            }}
          >
            {example.content}
          </Typography>
        </DialogContent>

        <Divider />

        {/* フッター：閉じる */}
        <DialogActions sx={{ px: 3, py: 1.5 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => setOpen(false)}
            sx={{
              px: 2.5,
              borderRadius: 1.5,
            }}
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
